<template>
  <div>
    <PrimaryButton light @click.native="openDialog" shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditBasicDetailsDialog
      :isOpen="isDialogOpen"
      @close="closeDialog"
      v-if="isDialogOpen"
    />
  </div>
</template>

<script>
import EditBasicDetailsDialog from "@/views/settings/components/dialogs/EditBasicDetailsDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";

export default {
  name: "EditBasicDetailsAction",
  components: { PrimaryButton, EditBasicDetailsDialog },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>

<style scoped></style>
